import { apiGet, apiSend } from './client'
import type { NotificationInbox } from './types'

export function fetchNotifications(limit = 30, signal?: AbortSignal): Promise<NotificationInbox> {
  return apiGet<NotificationInbox>(`/notification?limit=${limit}`, { signal })
}

export function markNotificationRead(id: string, read = true): Promise<null> {
  return apiSend(`/notification/${id}/read`, 'PUT', { read })
}

export function markAllNotificationsRead(): Promise<null> {
  return apiSend('/notification/read', 'PUT', {})
}
